"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _KYCSidePaneTypeSwitch = require("./KYCSidePaneTypeSwitch");
var _kycLevelsSelectors = require("../../redux/selectors/kycLevelsSelectors");
var _authActions = require("../../redux/actions/authActions");
var _path = _interopRequireDefault(require("../../helpers/path"));
var _StandaloneKYCComponent = _interopRequireDefault(require("./StandaloneKYCComponent"));
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    component: (0, _KYCSidePaneTypeSwitch.getKYCFormComponent)((0, _kycLevelsSelectors.kycLevelFormSelector)(state).kycConfig),
    HideUpfrontCloseButton: _config["default"].KYC.HideUpfrontCloseButton,
    showCancelButton: true
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: function onSubmit() {
      return dispatch(ownProps.history.push((0, _path["default"])(_config["default"].Navigation.landingPage)));
    },
    onClose: function onClose() {
      return dispatch((0, _authActions.logout)());
    }
  };
};
var _default = exports["default"] = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_StandaloneKYCComponent["default"]));